import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AboutBannerImg from '../assets/images/about-banner.png';
const AboutBanner = () => {
   return (
    <section className="about-banner-section">
        <Row>
          <Col lg={6} md={12} className='about-content-box align-self-center'>
            <div className="about-content">
              <h1 className="about-title">
                Your <span>trusted</span> home<br />
                for getting home
              </h1>
              <p className="about-description">
                Jambobay is the housing super app — an ecosystem of products and services designed to provide a seamless, end-to-end transaction experience for renters, shoppers, buyers and sellers, as well as the real estate professionals who serve them.
              </p>
              <p className="about-subtitle">
                Jambobay has been helping people get homes.
              </p>
            </div>
          </Col>
          <Col lg={6} md={12}>
            <div className="about-image">
              <img 
                src={AboutBannerImg}
                alt="Modern House" 
                className="house-img"
              />
            </div>
          </Col>
        </Row>
    </section>
  );
}

export default AboutBanner;